export const dialog = {
    '& .MuiDialog-paper': {
        background: 'rgb(6, 6, 56)',
        border: '1px solid rgba(187, 188, 188, 0.18)',
        borderRadius: '24px',
        boxShadow: '0px 48px 80px -32px rgba(0,0,0,0.8), 0px 0px 0px 1px rgba(0,120,255,0.18)',
        padding: '28px !important',
        width: '100%',
        maxWidth: '360px !important',
        position: 'relative',
        margin: '16px',
        textAlign: 'center',
    },
};

export const backdrop = {
    background: 'rgba(1, 1, 52, 0.72)',
    backdropFilter: 'blur(8px)',
};

export const dismissButton = {
    position: 'absolute',
    top: 12,
    right: 12,
    width: 32,
    height: 32,
    padding: '8px',
    borderRadius: '8px',
    color: 'rgba(187, 188, 188, 1)',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
        color: '#fff',
        background: 'rgba(255,255,255,0.05)',
    },
};

export const iconWrapper = (isSuccess) => ({
    width: 56,
    height: 56,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: isSuccess
        ? 'linear-gradient(135deg, rgba(0,212,86,0.22), rgba(0,212,86,0.10))'
        : 'linear-gradient(135deg, rgba(255,71,71,0.22), rgba(255,71,71,0.10))',
    border: isSuccess
        ? '1px solid rgba(0,212,86,0.32)'
        : '1px solid rgba(255,71,71,0.32)',
    mx: 'auto',
    mb: '16px',
    mt: '8px',
});

export const iconStyle = (isSuccess) => ({
    fontSize: 28,
    color: isSuccess ? 'var(--ecal-green)' : '#FF4747',
});

export const title = {
    fontSize: '18px',
    fontWeight: 600,
    color: '#fff',
    lineHeight: '28px',
    mb: '8px',
};

export const subMessage = {
    fontSize: '14px',
    fontWeight: 400,
    color: 'rgba(187,188,188,1)',
    lineHeight: '20px',
    mb: '24px',
};

export const actionsRow = {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
};

export const confirmButton = {
    width: '100%',
    height: '45px',
    background: 'linear-gradient(90deg, #0078FF 0%, #00D7FF 100%)',
    borderRadius: '999px',
    fontSize: '15px',
    fontWeight: 600,
    color: '#fff',
    border: 'none',
    cursor: 'pointer',
    fontFamily: 'inherit',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'filter 0.2s ease',
    '&:hover': { filter: 'saturate(1.15)' },
    '&:disabled': { cursor: 'default', filter: 'saturate(0.85)', opacity: 0.85 },
};

export const cancelButton = {
    width: '100%',
    height: '45px',
    background: 'transparent',
    borderRadius: '999px',
    fontSize: '15px',
    fontWeight: 500,
    color: 'rgba(187,188,188,1)',
    border: '1px solid rgba(187,188,188,0.20)',
    cursor: 'pointer',
    fontFamily: 'inherit',
    transition: 'border-color 0.18s ease, color 0.18s ease',
    '&:hover': { borderColor: 'rgba(187,188,188,0.45)', color: '#fff' },
    '&:disabled': { cursor: 'default', opacity: 0.5 },
};

export const noteRow = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',
    mt: '16px',
};

export const noteIcon = {
    fontSize: 14,
    color: 'rgba(187,188,188,0.7)',
};

export const noteText = {
    fontSize: '12px',
    fontWeight: 400,
    color: 'rgba(187,188,188,0.7)',
    lineHeight: '16px',
};
